module.exports = __webpack_public_path__ + "static/ai-min-ac9a17b9b49590a8ce57e137e78cb50d.jpg";